/** Height of the app bar when in mobile playground layout. */
export const MOBILE_APPBAR_HEIGHT = 48;

/** Dense desktop toolbar height on playground (`MainAppBar` + split layout). */
export const PLAYGROUND_DESKTOP_APP_BAR_HEIGHT = 56;
